module.exports = __webpack_public_path__ + "static/media/marchangus.505bbf67.jpg";